import { SessionData } from 'owa-service/lib/types/SessionData';
import { ApolloClient, ApolloLink, NormalizedCacheObject } from '@apollo/client';
import { lazyCreateApolloClient } from '../lazyFunctions';

let apolloClient: Promise<ApolloClient<NormalizedCacheObject>> | null = null;
let apolloClientSync: ApolloClient<NormalizedCacheObject> | null = null;

export function getApolloClient() {
    ensureClientIsInitialized(apolloClient);
    return apolloClient;
}

export function getApolloClientSync() {
    ensureClientIsInitialized(apolloClientSync);
    return apolloClientSync;
}

export function initializeApolloClient({
    lazyResolvers,
    lazyCreateManagedQueryLink,
    sessionPromise,
}: {
    lazyResolvers: Promise<any>;
    lazyCreateManagedQueryLink: Promise<() => ApolloLink> | undefined;
    sessionPromise: Promise<SessionData>;
}) {
    apolloClient = Promise.all([
        lazyCreateApolloClient.import(),
        lazyResolvers,
        lazyCreateManagedQueryLink,
        sessionPromise,
    ]).then(([createApolloClient, resolvers, createManagedQueryLink, sessionData]) => {
        apolloClientSync = createApolloClient({ resolvers, createManagedQueryLink, sessionData });
        return apolloClientSync;
    });

    return apolloClient;
}

function ensureClientIsInitialized(value: any) {
    if (!value) {
        throw new Error('Apollo client has not been initialized yet.');
    }
}
